<template>
  <div class="page__bd">
	<div style="height:233px">
		<img style="width:100%" mode="aspectFit" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/header-a.png"/>
	</div>
	<div class="cli-body">
		<div class="cli-body-bg" v-if="activityGoodsInfo">
			<div class="quest-one">
				<span class="time-panel">{{time[0]}}</span><span class="que-wenhou">:</span>
				<span class="time-panel">{{time[1]}}</span><span class="que-wenhou">:</span>
				<span class="time-panel">{{time[2]||'00'}}</span>
				<span style="margin:0 20px">后停止砍价</span>
			</div>
			<div class="jan-yikuai">已砍<span class="mory-bun">{{activityGoodsInfo.haveBargainAmount||0}}元</span></div>
			<!-- <div class="age-bugs">
				<div style="width:{{activityGoodsInfo.haveBargainAmount/activityGoodsInfo.bargainAmount*546||0}}px"></div>
			</div> -->
			<div class="age-bugs" v-if="activityGoodsInfo.haveBargainAmount!=activityGoodsInfo.bargainAmount">
				<div :style="'width:'+activityGoodsInfo.haveBargainAmount/activityGoodsInfo.bargainAmount*223+'px'"></div>
			</div>
			<div class="age-bugs-df" v-if="activityGoodsInfo.haveBargainAmount==activityGoodsInfo.bargainAmount">
				<div ></div>
			</div>
			<div v-if="activityObj&&activityGoodsInfo.status<30">
				<button class="kan-botun-botun1" @click="shareShow=true">邀好友来砍价</button>
			</div>
			<div v-if="activityObj&&activityGoodsInfo.status>=30">
				<button class="kan-botun-botun-falg">已结束</button>
			</div>
			<div v-if="!activityObj">
				<!-- <button class="kan-botun-botun1"   v-if="activityGoodsInfo.status<30&&!isLogin" bindgetphonenumber="getPhoneNumber">帮他砍一刀</button> -->
				<div class="kan-botun-botun"  style="margin: 0 20px;" v-if="activityGoodsInfo.status<30&&buttonFlag==2" @click="tobeginAnswer">帮他砍一刀</div>
				<div class="kan-botun-botun-falg"  v-if="activityGoodsInfo.status>20">已结束</div>
				<button class="kan-botun-botun1" v-if="getGiftInfo&&activityGoodsInfo.status<30"  @click="shareShow=true">邀好友来砍价</button>
			</div>
			
		</div>

    <div  style="text-align: center;width: calc(100% - 24px);margin:0 12px;border-radius: 20px;" v-if="getGiftInfo&&getGiftInfo.newCustomer&&getGiftInfo.givenAward">
			<!-- <div class="title-lis-san"><span>恭喜获得</span></div> -->
			<!-- <image style="width:600px;height:220px" mode="widthFix" v-if="getGiftInfo.bargainAmount!=allRightPrice" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/cuppon.png"></image> -->
			<img style="width:100%;"  src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/qingxi.png"/>
			
		</div>
		<div class="cli-body-bg-gf" style="text-align: center;" v-if="getGiftInfo&&getGiftInfo.newCustomer&&!getGiftInfo.givenAward">
			<!-- <div class="title-lis-san"><span>恭喜获得</span></div> -->
			<!-- <image style="width:600px;height:220px" mode="widthFix" v-if="getGiftInfo.bargainAmount!=allRightPrice" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/cuppon.png"></image> -->
			<img style="width:100%;"   src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/qingxi.png"/>
			<div class="kan-botun-botun"   style="line-height: 60px;margin:0px 20px;margin-top:40px;" v-if="!getGiftInfo.givenAward"  @click="getGift">立即领取</div>
			<div style="width:100%;height:30px" v-if="!getGiftInfo.givenAward"></div>
		</div>

		<div class="cli-body-bg-gf" style="text-align: center;" v-if="!isLogin">
			<img style="width:100%;" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/get-pic-gift.png"/>
		</div>
		<div class="cli-body-bg-gf" style="text-align: center;" v-if="!activityObj&&getGiftInfo&&getGiftInfo.newCustomer&&cuponFlag==2">
			<img style="width:100%;" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/get-pic-gift.png"/>
		</div>
		<div class="cli-body-bg-gf" style="text-align: center;" v-if="isLogin&&!activityObj&&!getGiftInfo">
			<img style="width:100%;" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/get-pic-gift.png"/>
		</div>
		<div class="cli-body-bg-gf" style="margin-top:24px;text-align: center;" >
			<img style="width:100%;" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/lanpics.png"/>
		</div>

		<div class="cli-content-tab">
			<div class="title">
				<div >
					<span class="chiose" @click="changeTab(0)"  v-if="tabIndex==0"> 砍价排行</span>
          <span class="no-chiose" @click="changeTab(0)" v-else> 砍价排行</span>
				</div>
				<div>
					<span class="chiose" @click="changeTab(1)"  v-if="tabIndex==1">活动攻略</span>
          <span class="no-chiose" @click="changeTab(1)"  v-else>活动攻略</span>
				</div>
			</div>
			<div >

			</div>
			<div v-if="tabIndex==0" style="min-height: 200px;">
				<div style="text-align: center;height:200px;padding:50px" v-if="!relist||relist.length==0">
					<span style="color:#ccc">暂无好友砍价</span>
				</div>
				<div class="line-paople"  v-for="(item,index) in relist" v-bind:key="index">
					<div>
						<image class="avader" :src="item.headImgUrl||'https://mi.baozheng.cc/img/default_avatar.92027116.png'"></image>
					</div>
					<div style="margin-left: 10px">
						<div>
							<div class="nice-name">{{item.customerName}}</div>
							<span class="zang-icon">答题狂砍一刀</span>
						</div>
						<div class="time">
							{{item.ftime}}
						</div>
					</div>
					<div class="kandiao">
						砍掉{{item.bargainAmount}}元
					</div>
				</div>
				<!-- <div class="more-botton">
					<div style="width:200px;width: 100px;margin-left: calc(50% - 100px);">
						<p style="text-align: center;color:#CCCCCC">
							加载更多
						</p>
						<image style="width:40px;height:20px" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/header-a.png"></image>
					</div>
				</div> -->
			</div>
			<div style="padding:40px" class="pading-goods" v-if="tabIndex==1">
				<div>1.本次活动为邀请好友助力砍价活动。</div>
				<div>2.用户在确认诊断方案后，可以在付款前发起邀请好友助力砍价，限时1小时。</div>
				<div>3.邀请好友来砍价，本单最高可立减66元，砍价金额系统实时计算自动在总额中减去，多答多减。</div>
				<div>4.邀请好友答题，准确率越高，砍价金额越高。</div>
				<div>5.邀请的好友答对全部题目，即可获得奢侈品箱包免费清洗服务一次（可选连带上色下单，不包邮）；部分答对，可获得LV真皮精美小发卡一只（下单随包寄回）。 </div>
				
			</div>
		</div>
		<div style="height:30px;width:100%"></div>
	</div>
  <van-popup
      v-model="dialogQuession"
      closeable
      close-icon-position="top-left"
      :style="{ height: '444px',width:'315px',borderRadius:'5px'}"
    >
    <div style="width:calc(315px - 40px);padding:0 20px">
      <h1 style="text-align: center;margin: 30px 0 20px 0;">答题砍一刀</h1>
      <div class="kan-dist-df">答对越多，砍价越多（每人限答一次）</div>
	    <div class="kan-title">第{{questionIndex+1}}题/共5题</div>
	    <div class="ask-title">{{questionIndex+1}}.{{questions[questionIndex].questionName}}？</div>
	    <van-button class="ask-anser-2"  v-for="(item,index) in questions[questionIndex].questionOptions" @click="chiose(item.option,questions[questionIndex].id)" v-bind:key="index"><span>{{item.optionInfo}}</span></van-button>
    </div>
    
    </van-popup>
	

  <van-popup
      v-model="askEndFlag"
      closeable
      close-icon-position="top-left"
      :style="{ height: '444px',width:'315px',borderRadius:'5px'}"
    >
    <div style="width:calc(315px - 40px);padding:0 20px;">
      <h1 style="text-align: center;margin: 30px 0 20px 0;">棒棒哒！共答对{{qres.answerRightQuestionCount}}道题</h1>
      <div class="kan-dist" style="font-size:28rpx">成功砍价<span class="get-num">{{qres.bargainAmount}}</span><span class="get-num-danwei">元</span></div>
      <div>
       
        <img   src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/qingxi.png" style="width:100%;height: 150px;"/>
      </div>
      <van-button class="ask-get-button" @click="getGift(1)"    style="line-height: 60rpx;width: 500rpx;">点击领取</van-button>
      <div class="ask-get-dis">关注“包拯公众号”获取更多小知识</div>
    </div>
  </van-popup>
  <!-- <van-popup
      v-model="askEndFlag"
      closeable
      close-icon-position="top-left"
      :style="{ height: '444px',borderRadius:'5px'}"
    >
    <div style="width:300px;padding:40px">
      <div class="kan-dist" style="font-size:28rpx">成功答对<span class="get-num">{{qres.bargainAmount}}</span><span class="get-num-danwei">元</span></div>
      <div>
        <img  v-if="qres.bargainAmount==10" src="https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/qingxi.png" style="width:100%;height: 325rpx;"/>
      </div>
      <button class="ask-get-button" @click="getGift(1)"   style="line-height: 60rpx;width: 500rpx;">点击领取</button>
      <div class="ask-get-dis">关注“包拯公众号”获取更多小知识</div>

    </div>
    
  </van-popup> -->

  <van-popup
      v-model="qusultFlag"
      closeable
      close-icon-position="top-left"
      :style="{ height: '244px',width:'315px',borderRadius:'5px'}"
    >
    <div style="width:calc(315px - 40px);padding:30px 20px">
      <div class="kan-dist" style="font-size:28rpx">成功为好友砍价<span class="get-num">{{qres.bargainAmount}}</span><span class="get-num-danwei">元</span></div>
      <van-button class="ask-get-button" @click="shareShowEvent"    style="line-height: 60rpx;width: 500rpx;">邀请好友砍价</van-button>
      <div class="ask-get-dis">关注“包拯公众号”获取更多小知识</div>
    </div>
  </van-popup>
  <van-popup v-model="codeFlag" style="background-color: rgba(127, 255, 212, 0);">
      <div style="width: 300px;">
         <img src="/images/base/getCodeSucee.png" alt="" style="width:100%">
      </div>
     
    </van-popup>
  <van-popup v-model="shareShow" style="background-color: rgba(127, 255, 212, 0);">
      <div style="margin-bottom: 400px;">
         <img src="/images/home/share-dialog.png" alt="" style="width:100%">
      </div>
     
    </van-popup>
</div>
</template>

<script>
import publicObj from "@/assets/js/public";
import callmeApi from "@/axios/callme";
import wxShare from "@/assets/js/wx.share";
import { Toast } from "vant";
import api from "./api";
import zhugeObj from "@/assets/js/track";
const TIME_COUNT = 60;
let trbulTime = null
export default {
  name: "sendIndex",
  data() {
    return {
      allRightPrice:6,
      dialogShow: false,
      dialogQuession:false,
      showOneButtonDialog: false,
      tabIndex:0,
      shareShow:false,
      buttonFlag:2,//1:老用户,2:没参加,3:已参加
      cuponFlag:1,
      codeFlag:false,
      dialogFlag:false,
      askEndFlag:false,
      activityObj:null,
      showCodeImg:true,
      questionFlag:false,
      qusultFlag:false,
      recordVoList:[],
      questionIndex:0,
      timeReal:0,
      qres:{
        bargainAmount:10,
        answerRightQuestionCount:2
      },
      buttons: [{text: '取消'}, {text: '确定'}],
      oneButton: [{text: '不了',extClass:'no-button'}, {text: '好，继续分享',extClass:'yes-button'}],
      asker:[{text:'英国'},{text:'美国'},{text:'泰国'}],
    //   askEnd:{
    //       title:'恭喜你全答对啦！超棒！',
    //       getMoney:15,
    //       goodsUrl:'https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/add-finsh.png'
    //   }
      askEnd:{
        title:'恭喜你全答对啦！超棒！',
        getMoney:10,
        goodsUrl:'https://baozheng-assets-new.baozheng.cc/assets/bz/miniprogram/fajia-pic.png'
      },
      time:['00','00','00'],
      relist:[{
          headImgUrl:'https://baozheng-nice-new.baozheng.cc/uploads/bag/order/front/000/023/566/ad5bf62b.jpg?x-oss-process=image/resize,m_fill,h_300,w_300,color_FFFFFF,image/format,jpg,q_80',
          customerName:'jiersdfwe',
          ftime:'20-12-03',
          bargainAmount:'324'
      }],
      activityGoodsInfo: {
        orderAmount:23,
        haveBargainAmount:3,
        status:20,
        goodsPics: [
          "https://baozheng-nice-new.baozheng.cc/uploads/bag/order/front/000/023/566/ad5bf62b.jpg?x-oss-process=image/resize,m_fill,h_300,w_300,color_FFFFFF,image/format,jpg,q_80"
        ]
      },
      getGiftInfo:null,
      questions:[{
        questionName:'缝纫工v热狗v人',
        questionOptions:[
          {
            optionInfo:'refreGeqgrqg歌曲过热个'
          },
          {
            optionInfo:'refreGeqgrqg歌曲过热个'
          },
          {
            optionInfo:'refreGeqgrqg歌曲过热个'
          },
          {
            optionInfo:'refreGeqgrqg歌曲过热个'
          }
        ]
      }]
    };
  },
  watch: {},
  computed: {
    isLogin() {
      return this.$store.state.token;
    },
    customerId() {
      return localStorage.getItem("customerId");
    }
  },
  created() {
    const  obj = this.$route.query
    this.bargainActivityRecordId = obj.activityGoodsInfoId
    this.open = obj
  },
  mounted() {
    const  obj = this.$route.query
    this.queryObject = obj
    this.getfersh()
    this.setShare()
  },
  methods: {
    setShare(){
      setTimeout(()=>{
        let shareBody = {
          desc : '姐妹们一起来砍价',
          title : '还能免费洗包！',
          link :location.href,
          imgUrl:'/images/base/share-kanyidao.png'
        }; 
        
        wxShare(shareBody).then(()=>{
          
        });
      },1000)
    },
    shareShowEvent(){
      this.qusultFlag = false
      this.shareShow = true
    },
    chiose(selectOption,questionId){
      let {recordVoList} = this
      recordVoList.push({
        questionId,
        selectOption
      })
      if(this.questionIndex==4){
        this.submit()
      }else{
        this.questionIndex++
        this.recordVoList = recordVoList
      }
    },
    setFlagShow(){
      if(this.qres.newCustomer){
        this.askEndFlag = true
        this.qusultFlag = false
      }else{
        this.askEndFlag = false
        this.qusultFlag = true
      }
      
    },
    async submit(){
      let bargainActivityRecordDetailId = this.beginAnswer.id
      let {recordVoList} = this 
      this.qres =  await api.submitResult({bargainActivityRecordDetailId,recordVoList})
      this.dialogQuession = false
      this.setFlagShow()
      this.getfersh()
    },
    async getGift(index){
      let res =  await api.newCustomerDrawAward()
      this.results = res
      this.showCodeImg = true
      this.askEndFlag = false 
      this.qusultFlag = false
      Toast('已领取！');
      if(index==1){
        this.codeFlag = true
      }
      // this.previewImage()
      this.getfersh()
    },
    async getQuestions(){
      this.questions =  await api.questions({bargainActivityRecordId:this.beginAnswer.bargainActivityRecordId})
      this.dialogQuession = true
      this.questionIndex = 0
    },
    async tobeginAnswer(){
      try{
        let res =  await api.beginAnswer({bargainActivityRecordId:this.bargainActivityRecordId})
        this.beginAnswer = res
        this.recordVoList=[]
        this.getQuestions()
      }catch(e){
        localStorage.setItem('actionType','bargain');
      }
      
    },
    async getDetailInfo(){
      try{
      let res =  await api.giftDetailInfo() 
      if(!res){
          this.cuponFlag = 2
          this.buttonFlag =2
        }else{
          this.cuponFlag = 1
          this.buttonFlag = 3
        }
        this.getGiftInfo=res
      }catch(e){
        this.isLogin = false
      }  
    },
    getfersh(){
      clearInterval(trbulTime)
      this.getActivityInfo()
      this.isLogin&&this.getDetailInfo()
      this.activityGoodsInfo&&this.barrainList()
    },
    async recordInfo(){
      this.activityObj =  await api.recordInfo({bargainActivityId:this.activityGoodsInfo.bargainActivityId}) 
    },
    async getActivityInfo(){
      const activityGoodsInfo = await api.getActivityBInfo({bargainActivityRecordId:this.bargainActivityRecordId})
      activityGoodsInfo.haveBargainAmount =(+activityGoodsInfo.haveBargainAmount)
      this.activityGoodsInfo = activityGoodsInfo
      activityGoodsInfo.countDownExpired&&this.goTime()
      if(!activityGoodsInfo.countDownExpired){
        this.timeReal = 0
      }
      // this.recordInfo()
      this.barrainList()
    },
    changeTab(index){
      this.tabIndex = index
    },
    async barrainList(){
      let  bargainActivityRecordId = this.bargainActivityRecordId
      const res =  await api.getKanjiaList({bargainActivityRecordId})
      let arrayOfSquares=[]
      if(res){
        arrayOfSquares = res.map(function (item) {
          item.ftime = item.createTime.slice(5,16);
          return item
        });
      }
      this.relist = arrayOfSquares
      this.tabIndex = arrayOfSquares.length==0?1:0
    },
    goTime(){
      this.timeReal = this.activityGoodsInfo.countDownExpired
      if(this.timeReal<1000){
          this.timeReal = 0
      }
      trbulTime = setInterval(()=>{
        this.toHHmmss()
      },1000)
    },
    toHHmmss() {
      this.timeReal= this.timeReal-1000
      let {timeReal} = this
      if(timeReal<=0){
        clearInterval(trbulTime)
      }
      let s;
      let hours = parseInt((timeReal % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((timeReal % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = (timeReal % (1000 * 60)) / 1000;
      s = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
      let ss = s.split(':')
      let df = Math.round(ss[2])
      ss[2] = df< 10 ? ('0' + df) : df
      this.time = ss
    },
  }
};
</script>

<style scoped lang="scss">
/* Bargaining/pages/lead/index.wxss */
.page__bd{
  background-color: #DEF2F2;
}
/* Bargaining/pages/lead/index.wxss */
.page__bd{
  background-color: #DEF2F2;
}
.cli-body{
  width: 100%;
}
.cli-body-goods{
  height: 212px;
  width: calc(100% - 48px);
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
  position: relative;
  top: -24px;
}
.cli-body-bg{
  width: calc(100% - 48px);
  height: 520px;
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
  position: relative;
  top: -48px;
}
.cli-body-bg-gf{
  width: calc(100% - 48px);
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
}
.cli-body-goods-top{
  height: 120px;
  padding: 24px 34px;
  padding-bottom: 0;

}
.cli-body-goods-boom{
  height: 70px;
  line-height: 70px;
  background-color: #FFF8DF;
  color: #8B3620;
  font-size: 24px;
  padding-left: 20px;

}
.pic-list{
  width:350px;
  float:right;
}
.pic-list image{
  width:80px;
  height: 80px;
  margin-right: 20px;
}
.kan-botun-botun{
  // margin-left: calc(50% - 301px)!important;
  // width: 602px!important;
  height: 100px;
  line-height:100px;
  text-align: center;
  color: #fff;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  box-shadow: 0px 10px 10px 0px rgba(99, 191, 191, 0.5);
  border-radius: 50px;
}
.kan-botun-botun1{
  margin-left: calc(50% - 301px)!important;
  width: 602px!important;
  height: 100px;
  line-height:60px;
  text-align: center;
  color: #fff;
  font-weight: 500;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  box-shadow: 0px 10px 10px 0px rgba(99, 191, 191, 0.5);
  border-radius: 50px;
}
.kan-botun-botun-falg{
  margin-left: calc(50% - 301px)!important;
  width: 602px!important;
  height: 100px;
  line-height:100px;
  text-align: center;
  color: #fff;
  background: linear-gradient(317deg, #afafaf 0%, #d0d0d0 100%);
  box-shadow: 0px 10px 10px 0px #afafaf;
  border-radius: 50px;
}
.kan-botun-botun2{
  margin-left: calc(50% - 250px)!important;
  width: 500px!important;
  height: 100px;
  line-height:60px;
  text-align: center;
  color: #fff;
  font-weight: 500;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  box-shadow: 0px 10px 10px 0px rgba(99, 191, 191, 0.5);
  border-radius: 50px;
}
.age-bugs{
  margin:50px 0;
  margin-left: calc(50% - 273px);
  width: 546px;
  height: 24px;
  background: #DEF2F2;
  border-radius: 12px;
}
.jan-yikuai{
  color:#333333;
  font-size:36px;
  text-align: center;
  margin-top: 30px;
}
.age-bugs div{
  width: 246px;
  height: 24px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  background: #7ADFDF;
}
.quest-one{
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #8F3D27;
  line-height: 24px;
  text-align: center;
  padding: 50px 0;

}
.time-panel{
  width: 52px;
  height: 32px;
  background: #8F3D27;
  border-radius: 4px;
  color: #fff;
  padding: 5px 10px;
}
.que-wenhou{
  padding: 5px 10px;
}
.mory-bun{
  font-size: 64px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F24949;
  line-height: 64px;

}
.cli-content-tab{
  width: calc(100% - 48px);
  margin:0 24px;
  background: #FFFFFF;
  border-radius: 20px;
  margin-top: 30px;
}
.cli-content-tab .title{
  width:100%;
  height:80px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: #EFEFEF;

}
.cli-content-tab .title div{
  width: 50%;
  text-align: center;
  float: left;
  line-height: 80px;
  height:80px;
}
.chiose{
  border-bottom-style: solid;
  border-bottom-width: 6px;
  border-color: #7ADFDF;
  padding: 12px 0;
  font-weight: 600;
}
.no-chiose{
  color: #666666;
  font-weight: 600;
}
.pading-goods{
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 40px;

}
.line-paople{
  height: 76px;
  width: calc(100% - 88px);
  padding: 20px 44px;

}
.line-paople div{
  float: left;
}
.line-paople div:nth-child(2){
  width: 380px;
}
.avader{
  width: 76px;
  height: 76px;
  border-radius: 50%;
}
.time{
  height: 24px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}
.zang-icon{
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #D5865B;
  line-height: 22px;
  padding: 5px 10px;
  border: 1px solid #D5865B;
}
.kandiao{
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #F24949;
  line-height: 28px;
  float: right;
  line-height: 50px;
}
.title-lis-san{
  font-size: 56px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 56px;
  margin: 20px 50px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: #EFEFEF;
  padding:20px 0;
}
.age-bugs-df{
  margin:50px 0;
  margin-left: calc(50% - 273px);
  width: 546px;
  height: 24px;
  background: #DEF2F2;
  border-radius: 12px;
}
.age-bugs-df div{
  height: 24px;
  border-radius: 12px;
  background: #7ADFDF;
}
.title-lis-san text{
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 56px;

}
.more-botton{
  margin-left: 44px;
  width: calc(100% - 88px);
  border-top-style: solid;
  border-top-width: 1px;
  border-color: #CCCCCC;
  padding: 30px 0;
}
/*-------------------dialog----------------------*/
.dialog-askq .weui-dialog__hd{
  display: none;
}
.dialog-fill .weui-dialog__hd{
  display: none;
}
.dialog-fill .weui-dialog__ft{
  /* display: none; */
  padding-top: 20px;
}
.dialog-fill .weui-dialog__bd{
  margin: 0;
  padding: 0;
}
.no-button{
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500!important;
  color: #7ADFDF!important;
  height: 100px;
  line-height: 100px;
  margin: 0 20px;
}
.yes-button{
  width: 280px;
  height: 100px;
  line-height: 100px;
  font-weight: 500!important;
  color: #fff!important;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  border-radius: 49px;
  margin: 0 20px;
}
.weui-dialog__btn::after{
  border-left:0!important
}
.dig-contxt{
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 50px;
  margin: 70px 0;
}
.kan-dist{
  width: 100%;
  text-align: center;
  height: 140px;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 37px;
}
.kan-dist-df{
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 37px;
}
.kan-title{
  width: 100%;
  height: 37px;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 37px;
  text-align:center;
  margin-top: 30px;
}
.ask-title{
  width: 100%;
  text-align: left;
  margin:50px 0;
  font-size: 34px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
}
.ask-anser{
  width: 100%;
  height: 74px;
  background: #7ADFDF;
  border-radius: 40px;
}
.ask-anser-2{
  width:100%!important;
  height: 74px;
  text-align: left;
  padding: 0 80px;
  line-height: 74px;
  border-radius: 40px;
  border: 2px solid #979797;
  margin-bottom: 40px;
}
.dialog-yidap .weui-dialog__ft{
  display: none;
}
.get-num{
  font-size: 92px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F24949;
  line-height: 92px;

}
.get-num-danwei{
  font-size: 44px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 44px;
}
.ask-get-button{
  width:100%;
  height: 100px;
  background: linear-gradient(317deg, #00A6A6 0%, #7ADFDF 100%);
  /* box-shadow: 0px 20px 20px 0px rgba(99, 191, 191, 0.5); */
  border-radius: 100px;
  line-height: 100px;
  color: #fff;
  margin:30px 0;
  font-size: 36px;
}
.ask-get-dis{
  width: 100%;
  height: 48px;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 48px;
  margin: 20px 0;
}
.dialog-yidap .weui-dialog__bd{
  margin-bottom: 0!important;
}
.disaag .weui-dialog__bd{
  margin-bottom: 50px!important;
}
.title-code{
  width: 100%;
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 56px;

}
.dialog-code .weui-dialog__ft{
  display: none;
}
.dialog-code .weui-dialog__hd{
  display: none;
}
.dialog-code .weui-dialog__bd{
  margin: 100px 0;
}
.nice-name{
  /* width: 155px; */
  height: 60px;
  overflow: hidden;
  margin-right: 15px;
}
.hove-oubt{
  background-color:#7ADFDF;
}
</style>
